import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Why Get a <span>Healthcare Software Solution</span> for Patient
              Care?
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              With healthcare software solutions ready to improve patient care,
              it is important to use modern tools adapted to the industry's
              specific needs. As your trusted healthcare software development
              partner, we promote patient-centric solutions that improve
              treatment quality and streamline operations throughout the
              healthcare industry.
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Improved Patient Engagement</h6>
                <p>
                  Allow patients to actively participate in their healthcare
                  journey by providing user-friendly interfaces and interactive
                  features.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Improved Accessibility</h6>
                <p>
                  Provide patients with easy access to medical records,
                  appointment scheduling, and telemedicine services from the
                  comfort of their own homes.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Personalized Care Delivery</h6>
                <p>
                  Use data insights to adapt therapies, medication reminders,
                  and wellness recommendations to each patient's specific
                  requirements.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Streamlined Communication</h6>
                <p>
                  Allow for smooth communication and collaboration among
                  healthcare experts, resulting in rapid information
                  transmission and coordinated care delivery.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Enhanced Clinical Decision-Making</h6>
                <p>
                  Provide doctors with real-time access to patient data, medical
                  histories, and diagnostic tools, allowing them to make
                  informed treatment decisions.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Regulatory Compliance & Data Security</h6>
                <p>
                  Maintain compliance with healthcare laws such as HIPAA and
                  GDPR while ensuring patient confidentiality and privacy
                  through strong data security standards.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
